(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-styles"] && !Shopify.designMode) return;
  try {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setUpHeroMotion = () => {
    if (window.matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll('.hero').forEach((hero) => {
      if (hero.querySelector('.fo-v5-motion-toggle')) return;

      const control = document.createElement('button');
      control.type = 'button';
      control.className = 'fo-v5-motion-toggle';
      control.setAttribute('aria-label', 'Pause background animation');
      control.setAttribute('aria-pressed', 'false');
      control.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 3h3v14H5zm7 0h3v14h-3z"/></svg>';
      hero.append(control);

      control.addEventListener('click', () => {
        const paused = hero.dataset.foMotionPaused !== 'true';
        hero.dataset.foMotionPaused = String(paused);
        control.setAttribute('aria-pressed', String(paused));
        control.setAttribute('aria-label', paused ? 'Play background animation' : 'Pause background animation');
        control.innerHTML = paused
          ? '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M6 3l11 7-11 7z"/></svg>'
          : '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 3h3v14H5zm7 0h3v14h-3z"/></svg>';
      });
    });
  };

  const setUpSectionMotion = () => {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('fo-v5-motion-ready');
    const sections = [...document.querySelectorAll('main .shopify-section:not(:first-child)')];
    sections.forEach((section) => section.classList.add('fo-v5-reveal'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08 });

    sections.forEach((section) => observer.observe(section));
  };

  const setUpSliderKeyboard = () => {
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      const card = event.target.closest('.ui-test-product-list product-card, .product-recommendations product-card');
      if (!card) return;

      const section = card.closest('.ui-test-product-list, .product-recommendations');
      const cards = [...section.querySelectorAll('product-card')];
      const index = cards.indexOf(card);
      const targetIndex = event.key === 'ArrowRight' ? index + 1 : index - 1;
      const target = cards[targetIndex];
      if (!target) return;

      event.preventDefault();
      const link = target.querySelector('.product-card__link');
      link?.focus();
      target.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    });
  };

  const initializeV5Enhancements = () => {
    setUpHeroMotion();
    setUpSectionMotion();
    setUpSliderKeyboard();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeV5Enhancements, { once: true });
  } else {
    initializeV5Enhancements();
  }
  } catch(e) { console.error(e); }
})();

})();
